export default function GS_Introduction() {
  return (
    <div className="p-4">
      <h1>GS Introduction</h1>
    </div>
  );
}
